import { initConfig } from './config/use-config';
import './style/arco-reset.scss';

initConfig().then(() => {
  if (process.env.NODE_ENV === 'development') {
    import('./main.dev');
  } else {
    import('./main.pro');
  }
});
